import { Component, OnInit } from '@angular/core';
import { Track } from '@app/core/models/Track';
import { AudioState } from '@app/core/states/audio.state';
import { LiveTrackingState } from '@app/core/states/live-tracking.state';
import { SearchService } from '@app/library/services/search.service';
import { TracksState } from '@app/library/states/tracks.state';
import { Select, Store } from '@ngxs/store';
import { CloseCurrentPanel, DynamicEnabledPanel } from '@radioking/shared/pannel-manager';
import { isArray } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'rk-playlist-add-track',
  templateUrl: './playlist-add-track.component.html',
  styleUrls: ['./playlist-add-track.component.scss'],
})
export class PlaylistAddTrackComponent implements OnInit, DynamicEnabledPanel {
  @Select(AudioState.isPlaying)
  isPlaying$: Observable<boolean>;

  @Select(AudioState.currentTrackPlaying)
  currentTrackPlaying$: Observable<Track>;

  allBox = '__ALL__';

  searchSubject = new BehaviorSubject<string>('');

  selectedBox = new BehaviorSubject<string>(this.allBox);
  tracks$: Observable<Track[]>;
  tracksUnfiltered$: Observable<Track[]>;

  constructor(
    private readonly store: Store,
    private readonly searchService: SearchService,
  ) {}

  hasToShowConfirmOnExit(): boolean {
    return false;
  }

  isDirty(): boolean {
    return false;
  }

  ngOnInit() {
    this.tracksUnfiltered$ = this.selectedBox.asObservable().pipe(
      switchMap(box => {
        if (box !== this.allBox) {
          return this.store
            .select(TracksState.trackBacDbNameUnfiltered)
            .pipe(map(fn => fn(box)));
        } else {
          const withChronics =
            ['Discover', 'Demo'].indexOf(
              this.store.selectSnapshot(LiveTrackingState.planDesc),
            ) < 0;

          return this.store.select(
            withChronics
              ? TracksState.allTracksForDropdown
              : TracksState.allTracksButChronicsForDropdown,
          );
        }
      }),
    );

    this.tracks$ = this.searchService
      .createTracksSearch(this.tracksUnfiltered$, this.searchSubject.asObservable(), true)
      .pipe(
        filter(val => isArray(val)),
        distinctUntilChanged(),
      );
  }

  closePanel() {
    this.store.dispatch(new CloseCurrentPanel(true));
  }

  selectBox(boxName: string) {
    this.selectedBox.next(boxName);
  }

  onChangeSearch(str: string) {
    if (typeof str === 'string') {
      this.searchSubject.next(str);
    }
  }
}
